import { render } from "./PoliticaCookies.vue?vue&type=template&id=862e839c&scoped=true"
const script = {}

import "@/assets/legal.css?vue&type=style&index=0&id=862e839c&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-862e839c"]])

export default __exports__